import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Card, message } from 'antd'

import { req_single_gam_graduateFresh, req_add_ars_reservationCase } from '../../api'

class ReservationMailModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////

    static propTypes = {
        qualify: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        awardee: {
            ResidentAddress: ''
        },
        item: {
            ReservationIProjectNid: this.props.qualify.ReservationIProjectNid,
            ClaimerCode: this.props.qualify.EligibleCode,
            ClaimerName: this.props.qualify.EligibleName,
            ClaimerPhone: '',
            QualifyKeyId: this.props.qualify.KeyId,
            ReservationType: 'SENDMAIL',
            ReservationTimeTag: '0000000000000000',
            ReservationLocation: '',
        }
    }

    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.api_single_graduateFresh()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_single_graduateFresh = async () => {
        const { token } = this.props.user
        const { EligibleCode } = this.props.qualify

        this.setState({ loading: true })
        const result = await req_single_gam_graduateFresh(EligibleCode, token)
        this.setState({ loading: false })
        const awardee = result
        if (result) {
            const { item } = this.state
            this.setState({ awardee })
            item.ClaimerPhone = result.MobilePrincipal
            item.ReservationLocation = result.ResidentCodeAddress
            this.setState({ item })
        }
        // console.log(awardee)
    }

    api_add_applycase = async (applycase) => {
        const token = this.props.user.token
        //this.setState({ loading: true })
        const result = await req_add_ars_reservationCase(applycase, token)
        //this.setState({ loading: false })
        if (result.status === 'success') {
            message.success('預約成功，獎項將採掛號郵件送達，謝謝')
        } else {
            message.error(result.message)
        }
    }

    /////////////////////////////////////////////////////////// 

    handleChange(event) {
        const { item } = this.state
        //console.log(event)
        Object.keys(item).forEach(propertyName => {
            if (event.target.id === propertyName && event.target.value !== null) {
                item[propertyName] = event.target.value.trim()
            }
        });
        this.setState({ item })
    }

    handleSubmit(event) {
        event.preventDefault()
        const row = this.state.item
        const errors = []

        if (!row.ReservationLocation.trim()) {
            errors.push('收件地址未填')
        }
        if (!row.ClaimerPhone.trim()) {
            errors.push('連絡電話未填')
        }

        if (errors.length === 0) {
            this.api_add_applycase(row)
        } else {
            let info = errors.join(',')
            message.error(info);
        }
    }

    /////////////////////////////
    render() {
        const { ResidentCodeAddress, MobilePrincipal } = this.state.awardee

        return (
            <Card>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>收件地址</label>
                                <input type="text" className="form-control text-primary" name="ReservationLocation" id="ReservationLocation" placeholder="請輸入收件地址" defaultValue={ResidentCodeAddress} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>連絡電話</label>
                                <input type="text" className="form-control text-primary" name="ClaimerPhone" id="ClaimerPhone" placeholder="請輸入連絡電話" defaultValue={MobilePrincipal} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <input type="submit" value="檢核預約資料" className="btn btn-primary btn-sm" />
                    </div>
                </form>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ReservationMailModal)